/*
 * Breakdown
 */

export const BreakdownSeverity = {
  NONE: "none",
  WARNING: "warning",
  CRITICAL: "critical",
};

export const BreakdownSeverityColor = {
  [BreakdownSeverity.NONE]: "green",
  [BreakdownSeverity.WARNING]: "orange",
  [BreakdownSeverity.CRITICAL]: "red",
};

export const BreakdownType = {
  ENGINE: "engine",
  TIRE: "tire",
};

export const BreakdownTire = {
  FRONT_LEFT: "frontLeft",
  FRONT_RIGHT: "frontRight",
  REAR_LEFT: "rearLeft",
  REAR_RIGHT: "rearRight",
};

/*
 * Camera
 */

export const CameraType = {
  CABIN: "cabin",
  FRONT: "front",
  RIGHT: "right",
  REAR: "rear",
  LEFT: "left",
  PANO: "360",
};

/*
 * Chat
 */

export const MessageSenderType = {
  DRIVER: "driver",
  OPERATOR: "operator",
};

export const MessageStatus = {
  SENT: "SENT",
  PENDING: "PENDING",
  FAILED: "FAILED",
  DENIED: "DENIED",
};

/*
 * View
 */

export const PluginView = {
  COMPACT: 0,
  STANDARD: 1,
  LARGE: 2,
  FULL: 3,
};

export const AssistanceCategory = {
  BCALL: "bcall",
  ECALL: "ecall",
  SCALL: "scall",
};
